__turbopack_context__.v({
  "safeHtml": "safe-html-module__3xEUmq__safeHtml",
});
